<template>
    <div class="noMatches">
        <picture v-if="img">
            <source v-bind:srcset="img.webp" type="image/webp">
            <img
                class="noMatches-img"
                v-bind:src="img.origin"
                alt=""
            >
        </picture>
        <div v-if="title" class="noMatches-title">
            {{ title }}
        </div>
        <div v-if="content" class="noMatches-content">
            {{ content }}
        </div>
        <slot name="default" />
    </div>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { computed, defineComponent } from 'vue';
    import { getImage } from '@/libraries/helpers/imageHelper';

    export default defineComponent({
        name: 'NoContent',
        props: {
            imgType: {
                type: String as PropType<'noResult' | 'noRecords' | 'block'>,
                default: null,
            },
            title: {
                type: String,
                default: null,

            },
            content: {
                type: String,
                default: null,
            },
        },
        setup(props) {
            const imageGlob = import.meta.glob('../../assets/images/error/*.{png,webp}', {
                eager: true,
            });

            const img = computed(() => (props.imgType ? getImage(imageGlob, `img_${props.imgType}`) : null));

            return {
                img,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/common/noMatches";
</style>
